import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Unknown: 'Unknown',
  NotApplicable: 'Not applicable',
  IncompatibleUblFormat: 'Incompatible UBL format',
  SentByEmail: 'Sent via email',
  SentByPeppol: 'Sent via Peppol',
  Invoices: 'Invoices',
  Ready: 'Ready',
  NotReady: 'Not Ready',
  Customers: 'Customers',
  ActivationStatus: 'Activation status',
  PeppolOnboarding: 'Peppol onboarding',
  ReadyToSend: 'Ready to send',
  SentInvoices: 'Sent invoices',
  OwnCompany: 'Own company',
  RevenuePerMonth: 'Revenue Per Month',
  MostValuableCustomers: 'Most valuable customers',
  MostValuableCustomersComparison: 'Most valuable customers comparison',
  RecentRelations: 'Recent relations',
  SearchRelation: 'Search relation',
  Compliancy: 'Compliancy',
  FiscalYear: 'Fiscal year',
  BilledLast3FiscalYears: 'Billed last 3 fiscal years',
  BilledThisYear: 'Billed this year',
  SwitchToCurrentFiscalYear: 'Switch to current fiscal year',
  SwitchToComparisonFiscalYears: 'Switch to comparison for last 3 fiscal years',
  CompliancePerCriterion: 'Compliance per criterion',
  ComplianceOverview: 'Compliance overview',
  SwitchToCompliancyOverviewForAllCustomers: 'Switch to compliancy overview for all customers',
  SwitchToCompliancyPerType: 'Switch to compliancy per type',
  ErrorLoadingData: 'Error loading data',
  MyTodos: "My todo's",
  MyRegistrations: 'My registrations',
  NewRegistration: 'New registration',
  ChangeTodoStatus: 'Change todo status',
  CreateNewToDo: 'Create new to-do',
  OpenDetails: 'Open details',
  AddRegistration: 'Add registration',
  DeleteTodo: 'Delete todo',
  DeleteTodoConfirmationMsg: 'Are you sure you want to delete this todo?',
  OpenTodosInTasklist: "Open todo's in task list",
  AssignedToMe: 'Assigned to me',
  AddDashboard: 'Add dashboard',
  EditLayout: 'Edit layout',
  SaveLayout: 'Save layout',
  Cancel: 'Cancel',
  ResetToDefault: 'Reset to default',
  Today: 'Today',
  Yesterday: 'Yesterday',
  ThisWeek: 'This week',
  ThisMonth: 'This month',
  Deadline: 'Deadline',
  Description: 'Description',
  Relation: 'Relation',
  Overtime: 'Overtime',
  MissingHours: 'Missing hours',
  RemainingOvertimeHours: 'Remaining overtime hours',
  RemainingMissingHours: 'Missing hours',
  AbsenceCounters: 'AbsenceCounters',
  NoAbsencesFound: 'No absences found',
  CounterBalanceStartValue:
    '{balanceDays} days of {startValueDays} remaining ({balanceHours}/{startValueHours} hours)',
  AbsenceWidgetWithoutCounterTooltip: '{balanceDays} days registered ({balanceHours} hours)',
  AddAbsence: 'Add absence',
  ShowAbsencesInDays: 'Show absences in days',
  DaysAbbreviated: 'd',
  HoursAbbreviated: 'h',
  MinutesAbbreviated: 'm',

  // Task kpi's
  MyTasksKpis: 'My tasks - kpis',
  MyTasks: 'My tasks',
  FilterTodos: 'Show to-dos with these labels:',
  ConfigureKpis: 'Configure KPIs',
  ErrorWhileRetrievingMyTaskKpis: 'An error occurred while retrieving my task KPIs',
  NewConfigureYourTaskKpis: 'New! Configure the task KPIs you want to see',
  MyTasksFeatureHighlightTooltip:
    'Configure the KPIs you want to see and only include the tasks where you are next in line.',
  KPIs: 'KPIs',
  ExecutionDates: 'Execution dates',
  FillPeriodWithRecup: 'Fill period with recup',
});
export default messages;
